import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { breakpoints, palette } from '@themes/theme.helpers';
import { ReactNode } from 'react';

export type LayoutWithSummaryProps = {
  children?: ReactNode;
  header?: ReactNode;
  side?: ReactNode;
};

const StyledLayoutBox = styled(Box)`
  .cart-header {
    margin-bottom: 0;
    ${breakpoints.up('sm')} {
      border-bottom: 2px solid ${palette.primary('main')};
      margin-bottom: 16px;
    }
  }
`;

export const LayoutWithSummary = ({ children, side }: LayoutWithSummaryProps) => {
  return (
    <StyledLayoutBox
      sx={{
        display: { xs: 'flex', lmd: 'grid' },
        gridTemplateColumns: {
          xs: '1fr',
          lmd: '3fr 1fr',
        },
        gap: { xs: 2, xl: 4 },
        flexDirection: { xs: 'column', lmd: 'unset' },
      }}
    >
      <Box sx={{ gridColumn: 'span 1', overflow: 'auto' }}>{children}</Box>
      <Box
        sx={{
          gridColumn: 'span 1',
          mt: {
            lmd: '40px',
          },
        }}
      >
        {side}
      </Box>
    </StyledLayoutBox>
  );
};
